import React from "react";
import { useChartData } from "./UserChartData";
import LineChartWidget from "./LineChartWidget";
import { dashboardChartProps } from "../../core/dto/dashboard.dto";

const OutgoingCallsBarChart = ({ apiEndpoint, startDate, endDate, selectedLocation, selectedAgent, selectedCallType, selectedCallDirection, onChartLoaded }: dashboardChartProps) => {
    const payload = {
        from_date: startDate ? startDate.toLocaleDateString("en-CA") : null,
        to_date: endDate ? endDate.toLocaleDateString("en-CA") : null,
        call_type: selectedCallType || "",
        call_direction: selectedCallDirection || "outgoing call",
        agent_id: selectedAgent || "",
        location_id: selectedLocation || "",
        clientTZ: Intl.DateTimeFormat().resolvedOptions().timeZone,
        onChartLoaded
    };

    const chartData = useChartData(apiEndpoint, payload, onChartLoaded);

    return <LineChartWidget title={selectedCallDirection?.toLowerCase() === "all" ? "Call Direction Trends"
        : selectedCallDirection?.toLowerCase()?.includes("incoming")
            ? "Incoming Call Trends"
            : "Outgoing Call Trends"
    } chartData={chartData} />;
};

export default OutgoingCallsBarChart;
